import './PaykaLoaderIconStyles.scss';

const PaykaLoader = () => {
  return (
    <div className="payka-loader-icon">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

export default PaykaLoader